// extracted by mini-css-extract-plugin
export default {"logo":"pitpass-logo__logo___2h70l"};